import { graphql } from '@e-socna/data-layer';
import type { Id } from '@e-socna/data-layer';

import { Loading } from '../../components/Loading';
import { NoData } from '../../components/Illustrations/NoData';
import { Versions as VersionsCmp } from '../../components/Versions';
import { useGraphQLQuery } from '../../hooks/useGraphQLQuery.hook';

export const PersonVersions_Versions_QueryDocument = graphql(`
  query PersonVersions_Versions_Query($originalId: Id!) {
    findAllPersonVersionsForOneOriginalId(originalId: $originalId) {
      _id
      createdAt
      creatorId
      automaticMemo
      internalMemo
      memo
      version {
        _id

        code
        codingConfig {
          kind
          strategyId
          ... on CodingConfigManual {
            code
          }
        }

        kind
        typeId
        statusId
        color
        categoryIds
        isInternal
        isVip
        bankInfo {
          _id
          accountOwner
          bankCode
          branchCode
          accountNumber
          certificateKey
          iban
          swift
          domiciliation
        }
        contactInfo {
          _id
          email
          mobileNumber
          landlineNumber
          professionalNumber
          faxNumber
          website
        }
        billReceiverId
        billEmitterIds
        addresses {
          _id
          typeIds
          postalInfo {
            _id
            streetNumber
            route
            locality
            postalCode
            department
            region
            countryAlpha2
            building
            additional
            businessPostCode {
              postalCode
              distributorOfficeNumber
            }
            postOfficeBox
            inseeCode
          }
          locationInfo {
            _id
            coordinates
            projectionId
            altitude
            type
          }
          cadastralInfo {
            _id
            departmentCode
            municipalityCode
            oldMunicipalityCode
            districtCode
            section
            number
            sheet
          }
        }
        birthDate
        internalMemo
        memo
        creatorId
        createdAt
        updaterId
        updatedAt
        fullName
        civilityId
        signatureImageUri
        allMemberships {
          _id
          functions
          organizationId
          contextualRoleIds
          representativeTypeIds
          statusId
        }
      }
    }
  }
`);

interface Props {
  readonly originalId: Id;
}

export const Versions = ({ originalId }: Readonly<Props>) => {
  const { data, isSuccess } = useGraphQLQuery(
    PersonVersions_Versions_QueryDocument,
    { originalId },
    { enabled: !!originalId },
  );

  if (isSuccess) {
    const versions = data.findAllPersonVersionsForOneOriginalId;

    if (versions.length) {
      return <VersionsCmp versions={versions} />;
    }

    return <NoData />;
  }

  return <Loading />;
};
